import { camelToSnake, snakeToCamel } from "@/application/utils/keyConverter";
import Qs from "qs";

export const transformResponse = (response: string) => {
  if (typeof response === "string" && response.length > 0) {
    try {
      const result = JSON.parse(response);
      return snakeToCamel(result);
    } catch {
      return response;
    }
  }

  if (!response) {
    return {};
  }

  return response;
};

export const transformRequest = (data: Record<string, unknown>) => {
  if (data) {
    data = camelToSnake(data);
  }
  return data;
};

export const transformParams = (params: Record<string, unknown>) => {
  return Qs.stringify(camelToSnake(params))
    .replaceAll("true", "1")
    .replaceAll("false", "0");
};
